import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Dashboard from "@/pages/Dashboard";
import AthleteProfile from "@/pages/AthleteProfile";
import StockHub from "@/pages/StockHub";
import SubjectDetail from "@/pages/SubjectDetail";
import Presenter from "@/pages/Presenter";
import Admin from "@/pages/Admin";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-[#0B0D11] flex items-center justify-center text-[#9A9CA6]">
        <Loader2 className="h-6 w-6 animate-spin mr-2 text-[#E8833A]" /> Loading…
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Google OAuth returns to /app#session_id=... — process it before anything else.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/app" element={<Protected><Dashboard /></Protected>} />
      <Route path="/athlete/:id" element={<Protected><AthleteProfile /></Protected>} />
      <Route path="/stock" element={<Protected><StockHub /></Protected>} />
      <Route path="/animal/:id" element={<Protected><SubjectDetail kind="animal" /></Protected>} />
      <Route path="/contractor/:id" element={<Protected><SubjectDetail kind="contractor" /></Protected>} />
      <Route path="/presenter" element={<Protected><Presenter /></Protected>} />
      <Route path="/admin" element={<Protected><AdminOnly><Admin /></AdminOnly></Protected>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
